import { render, staticRenderFns } from "./ModalRetiradaNegativacao.vue?vue&type=template&id=634659f6"
import script from "./ModalRetiradaNegativacao.vue?vue&type=script&lang=js"
export * from "./ModalRetiradaNegativacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports